import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { type OptionInput } from '../types';
import { getOptions } from '../utils/getOptions';

export const getTopicTags = (id: number) =>
  axios
    .get<{ topic: { tags: Array<OptionInput> } }>(
      Routes.topics_topic_tags_path(id),
      {
        params: { format: 'json' },
      },
    )
    .then(({ data }) => getOptions(data.topic.tags))
    .catch(() => []);
